import { Buffer } from 'buffer'

const encodeBase64 = (str) => {
  return Buffer.from(str).toString('base64')
}

export default encodeBase64
